import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'app-card-expanding',
  templateUrl: './card-expanding.component.html'
})
export class CardExpandingComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  @Input() lightColour: boolean;

  constructor() { }

  ngOnInit() {
    // remove this after implementation is done
    console.log('CardExpanding component initialized with component data', this.rendering);

    this.lightColour = this.lightColour ? this.lightColour : (this.rendering.fields?.LightColour as any)?.value;
  }
}
